var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen.lock",
          value: _vm.fullscreenLoading,
          expression: "fullscreenLoading",
          modifiers: { fullscreen: true, lock: true }
        }
      ],
      staticClass: "edit-picker-box"
    },
    [
      _c(
        "el-dialog",
        { attrs: { title: "", visible: true, "before-close": _vm.closeBox } },
        [
          _vm.id == 0
            ? _c(
                "div",
                [
                  _c(
                    "el-form",
                    { attrs: { model: _vm.form, "label-width": "90px" } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "代采员:" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "50%" },
                              attrs: { filterable: "", placeholder: "代采员" },
                              model: {
                                value: _vm.form.admin_id,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "admin_id", $$v)
                                },
                                expression: "form.admin_id"
                              }
                            },
                            _vm._l(_vm.resData.memberOption, function(
                              item,
                              index
                            ) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { value: item.value, label: item.label }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "角色:" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "50%" },
                              attrs: { placeholder: "角色", filterable: "" },
                              model: {
                                value: _vm.form.role_type,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "role_type", $$v)
                                },
                                expression: "form.role_type"
                              }
                            },
                            _vm._l(_vm.resData.roleOption, function(
                              item,
                              index
                            ) {
                              return _c("el-option", {
                                key: item.key,
                                attrs: { value: item.key, label: item.label }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "城市:" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "50%" },
                              attrs: { placeholder: "城市", filterable: "" },
                              model: {
                                value: _vm.form.city,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "city", $$v)
                                },
                                expression: "form.city"
                              }
                            },
                            _vm._l(_vm.resData.cityOption, function(
                              item,
                              index
                            ) {
                              return _c("el-option", {
                                key: item.key,
                                attrs: { value: item.key, label: item.label }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "绑定代采组:" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "50%" },
                              attrs: {
                                multiple: "",
                                placeholder: "绑定代采组",
                                filterable: ""
                              },
                              model: {
                                value: _vm.form.pgids,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "pgids", $$v)
                                },
                                expression: "form.pgids"
                              }
                            },
                            _vm._l(_vm.resData.pgOption, function(item, index) {
                              return _c("el-option", {
                                key: item.key1,
                                attrs: { value: item.key1, label: item.label }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "状态:" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "50%" },
                              attrs: { placeholder: "状态" },
                              model: {
                                value: _vm.form.status,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "status", $$v)
                                },
                                expression: "form.status"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: { value: "1", label: "启用" }
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { value: "0", label: "禁用" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "" } },
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: { width: "25%" },
                              on: { click: _vm.closeBox }
                            },
                            [_vm._v("取消")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticStyle: { width: "25%" },
                              attrs: { type: "success" },
                              on: { click: _vm.submitData }
                            },
                            [_vm._v("确认")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.id > 0
            ? _c(
                "div",
                [
                  _c(
                    "el-form",
                    { attrs: { model: _vm.form, "label-width": "90px" } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "代采员:" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "50%" },
                              attrs: {
                                filterable: "",
                                placeholder: "代采员",
                                disabled: ""
                              },
                              model: {
                                value: _vm.form.admin_id,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "admin_id", $$v)
                                },
                                expression: "form.admin_id"
                              }
                            },
                            _vm._l(_vm.resData.memberOption, function(
                              item,
                              index
                            ) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { value: item.value, label: item.label }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "角色:" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "50%" },
                              attrs: { placeholder: "角色", filterable: "" },
                              model: {
                                value: _vm.form.role_type,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "role_type", $$v)
                                },
                                expression: "form.role_type"
                              }
                            },
                            _vm._l(_vm.resData.roleOption, function(
                              item,
                              index
                            ) {
                              return _c("el-option", {
                                key: item.key,
                                attrs: { value: item.key, label: item.label }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "城市:" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "50%" },
                              attrs: { placeholder: "城市", filterable: "" },
                              model: {
                                value: _vm.form.city,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "city", $$v)
                                },
                                expression: "form.city"
                              }
                            },
                            _vm._l(_vm.resData.cityOption, function(
                              item,
                              index
                            ) {
                              return _c("el-option", {
                                key: item.key,
                                attrs: { value: item.key, label: item.label }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "绑定代采组:" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "50%" },
                              attrs: {
                                multiple: "",
                                placeholder: "绑定代采组",
                                filterable: ""
                              },
                              model: {
                                value: _vm.form.pgids,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "pgids", $$v)
                                },
                                expression: "form.pgids"
                              }
                            },
                            _vm._l(_vm.resData.pgOption, function(item, index) {
                              return _c("el-option", {
                                key: item.key1,
                                attrs: { value: item.key1, label: item.label }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "状态:" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "50%" },
                              attrs: { placeholder: "状态" },
                              model: {
                                value: _vm.form.status,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "status", $$v)
                                },
                                expression: "form.status"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: { value: "1", label: "启用" }
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { value: "0", label: "禁用" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "" } },
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: { width: "25%" },
                              on: { click: _vm.closeBox }
                            },
                            [_vm._v("取消")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticStyle: { width: "25%" },
                              attrs: { type: "success" },
                              on: { click: _vm.submitData }
                            },
                            [_vm._v("确认")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cd184010", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cd184010","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/purchasegroup/components/EditMember.vue
// module id = null
// module chunks = 